import { defineComponent, ref, onMounted, createElementBlock, openBlock, createBlock, createCommentVNode, withCtx, createTextVNode, toDisplayString, createVNode } from 'vue';
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es72.js';

const _hoisted_1 = { class: "share-button" };
const _hoisted_2 = {
  key: 1,
  class: "share-button__copied"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ShareButton",
  props: {
    url: {},
    title: {},
    shareText: { default: "Share Download Link" },
    copyText: { default: "Copy Download Link" },
    copiedText: { default: "Copied to clipboard" },
    tag: {},
    styleType: { default: "secondary" },
    iconType: { default: "icon-left" },
    active: { type: Boolean, default: false },
    size: { default: "medium" },
    iconName: { default: "share" },
    iconScale: { default: 1 },
    disabled: { type: Boolean, default: false },
    expand: { type: Boolean },
    states: {},
    activeState: {}
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const shareLinkAvailable = ref(false);
    const isCopied = ref(false);
    const copyValueToClipboard = async (value) => {
      let timer;
      try {
        clearTimeout(timer);
        await navigator.clipboard.writeText(value);
        isCopied.value = true;
        timer = setTimeout(() => {
          isCopied.value = false;
        }, 5e3);
      } catch (err) {
        console.log("Clipboard error:", err);
      }
    };
    function shareLink(title, url) {
      if (navigator.share) {
        navigator.share({
          title,
          url
        }).then(() => {
          console.log("Thanks for sharing!");
        }).catch(console.error);
      } else {
        copyValueToClipboard(url);
      }
      emit("click", 0);
    }
    onMounted(() => {
      if (typeof window !== "undefined" && "navigator" in window) {
        shareLinkAvailable.value = "share" in navigator;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        !isCopied.value ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event) => shareLink(_ctx.title, _ctx.url)),
          class: "share-button__action",
          disabled: _ctx.disabled,
          styleType: _ctx.styleType,
          iconType: _ctx.iconType,
          active: _ctx.active,
          size: _ctx.size,
          iconName: _ctx.iconName,
          iconScale: _ctx.iconScale
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(shareLinkAvailable.value ? _ctx.shareText : _ctx.copyText), 1)
          ]),
          _: 1
        }, 8, ["disabled", "styleType", "iconType", "active", "size", "iconName", "iconScale"])) : isCopied.value ? (openBlock(), createElementBlock("span", _hoisted_2, [
          createVNode(_sfc_main$2, {
            name: "check",
            class: "share-button__copied-icon"
          }),
          createTextVNode(" " + toDisplayString(_ctx.copiedText), 1)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
